import "./Loader.css";
const Loader = () => {
  return (
    <div className="min-h-screen min-w-full flex justify-center items-center fixed top-10">
      <span class="loader"></span>
    </div>
  );
};

export default Loader;
